export const paginationQueryParams = (rowsPerPage, search, sortOrder, pageNo) => {
  return `offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&page=${pageNo}&search=${search}`;
};
